module.exports = __webpack_public_path__ + "img/mf.5d5f8a40.svg";